import * as client from './baseClient';

export const getPersonnel = (personnelId) =>
  client.get(`/api/personnels/${personnelId}`);

export const getAllPersonnels = (branchId) =>
  client.get(`/api/personnels/branch/${branchId}`);

export const createPersonnel = (personnel, loggedInUserId) =>
  client.post('/api/personnels', personnel, undefined, loggedInUserId);

export const updatePersonnel = (personnel, loggedInUserId) =>
  client.put(
    `/api/personnels/${personnel.id}`,
    personnel,
    undefined,
    loggedInUserId
  );

export const getCoursesForPersonnel = (personnelId) =>
  client.get(`/api/personnels/${personnelId}/courses`);
